import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getConversationById } from 'api/userSupportAPI';
import { handleError } from 'services/Error';
import { AppRoutes } from 'services/routes';
import { mapConversation, MESSAGES_LOCATION_HASH } from 'services/userSupportHelpers';

export const ConversationRedirect = () => {
    const { displayId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            let redirected = false;
            try {
                if (displayId) {
                    const conversation = await getConversationById({ displayId });

                    if (conversation) {
                        const mappedConversation = mapConversation(conversation);

                        if (mappedConversation.referralId) {
                            navigate(
                                {
                                    pathname: AppRoutes.wonReferralDetails(
                                        mappedConversation.referralId,
                                    ),
                                    hash: MESSAGES_LOCATION_HASH,
                                },
                                {
                                    replace: true,
                                    state: {
                                        conversationId: mappedConversation.conversationId,
                                    },
                                },
                            );
                            redirected = true;
                        }
                    }
                }
            } catch (error) {
                handleError('Unable to find conversation.', error as Error);
            }
            if (!redirected) {
                navigate(AppRoutes.allMessages);
            }
        })();
    }, [displayId, navigate]);

    return <BlankScreen />;
};
